
export const TOGGLE_MENU = 'toggle_menu';

export function toggleMenuAction(){
  return {
    type: TOGGLE_MENU
  }
}
